

































































import { Component, Vue, Emit, Prop } from "vue-property-decorator";

import { Dialog, Popup } from "vant";

/* eslint-disable @typescript-eslint/class-name-casing */
/* eslint-disable @typescript-eslint/camelcase */

@Component({
  components: {},
})
export default class NewSentence extends Vue {
  @Prop() show!: any;
  errors: any = [];
  new_sentences: any = {
    whoEn: null,
    whoBn: null,
    sentenceEn: null,
    sentenceBn: null,
  };

  @Emit("NewSentence")
  NewSentence() {
    return this.new_sentences;
  }
  @Emit("NewSentenceInTranslation")
  NewSentenceInTranslation() {
    return this.new_sentences;
  }

  checkRequired() {
    if (
      this.new_sentences.whoEn &&
      this.new_sentences.sentenceEn &&
      this.new_sentences.sentenceBn &&
      this.new_sentences.whoBn
    ) {
      return true;
    }
    this.errors = [];
    if (!this.new_sentences.whoEn) {
      this.errors.push("whoEn required.");
    }
    if (!this.new_sentences.whoBn) {
      this.errors.push("whoBn required.");
    }
    if (!this.new_sentences.sentenceEn) {
      this.errors.push("sentence En required.");
    }
    if (!this.new_sentences.sentenceBn) {
      this.errors.push("Sentence Bn required.");
    }
  }
  SaveSentence() {
    this.checkRequired();
    if (this.checkRequired()) {
      if (this.$route.name == "main.translations") {
        this.NewSentenceInTranslation();
      } else this.NewSentence();
    }
  }
  showPopup() {
    this.show = true;
  }
}
